import { readableDate } from '@occc-app/lib/format';
import { parseDate } from '@occc-app/lib/date';
import { TransactionStateChangeFragment, Transaction_Event_Type } from '@occc/graphql';

import { transactionEventTypeLabelsMap } from './transaction-details.constants';

import { DATE_FORMAT, getDateDiff } from '../utils';

type DateCell = (
  item: TransactionStateChangeFragment | null,
  index: number,
  stateChanges: (TransactionStateChangeFragment | null)[],
) => string;

export const getDateCell: DateCell = (item, index, stateChanges) => {
  if (index === 0) {
    return readableDate(item?.updatedAt, DATE_FORMAT);
  }

  return `+${getDateDiff(
    item?.updatedAt ? parseDate(item.updatedAt) : undefined,
    stateChanges?.[0]?.updatedAt ? parseDate(stateChanges?.[0]?.updatedAt) : undefined,
  )} ms`;
};

export const getTransactionEventTypeLabel = (transactionEventType: Transaction_Event_Type) => {
  return transactionEventTypeLabelsMap[transactionEventType] || transactionEventType;
};
